import React, { useState } from 'react';
import { PhoneIcon, MenuIcon, XIcon, ChevronDownIcon, MapPinIcon } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAutoRepairOpen, setIsAutoRepairOpen] = useState(false);
  const [isDieselFleetOpen, setIsDieselFleetOpen] = useState(false);
  const [isDotCdlOpen, setIsDotCdlOpen] = useState(false);
  const [isBlogsOpen, setIsBlogsOpen] = useState(false);
  // Mobile states
  const [mobileAutoRepairOpen, setMobileAutoRepairOpen] = useState(false);
  const [mobileDieselFleetOpen, setMobileDieselFleetOpen] = useState(false);
  const [mobileDotCdlOpen, setMobileDotCdlOpen] = useState(false);
  const [mobileBlogsOpen, setMobileBlogsOpen] = useState(false);
  // Mobile sub-menu states for Auto Repair
  const [mobileGroup1Open, setMobileGroup1Open] = useState(false);
  const [mobileGroup2Open, setMobileGroup2Open] = useState(false);
  const [mobileGroup3Open, setMobileGroup3Open] = useState(false);
  // Mobile sub-menu states for Diesel & Fleet
  const [mobileDieselGroup1Open, setMobileDieselGroup1Open] = useState(false);
  const [mobileDieselGroup2Open, setMobileDieselGroup2Open] = useState(false);
  const [mobileDieselGroup3Open, setMobileDieselGroup3Open] = useState(false);
  const [mobileDieselGroup4Open, setMobileDieselGroup4Open] = useState(false);
  // Mobile sub-menu states for DOT/CDL
  const [mobileDotGroup1Open, setMobileDotGroup1Open] = useState(false);
  const [mobileDotGroup2Open, setMobileDotGroup2Open] = useState(false);
  const [mobileDotGroup3Open, setMobileDotGroup3Open] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setMobileAutoRepairOpen(false);
    setMobileDieselFleetOpen(false);
    setMobileDotCdlOpen(false);
    setMobileBlogsOpen(false);
    setMobileGroup1Open(false);
    setMobileGroup2Open(false);
    setMobileGroup3Open(false);
    setMobileDieselGroup1Open(false);
    setMobileDieselGroup2Open(false);
    setMobileDieselGroup3Open(false);
    setMobileDieselGroup4Open(false);
    setMobileDotGroup1Open(false);
    setMobileDotGroup2Open(false);
    setMobileDotGroup3Open(false);
  };
  const autoRepairGroups = [{
    heading: 'Services',
    links: [{
      label: 'Auto Repair Services',
      href: '/auto-repair-mechanic.html'
    }, {
      label: 'Basic Car / Truck Maintenance',
      href: '/BasicCarandTruckMaintenance.html'
    }, {
      label: 'Automotive Tune-up',
      href: '/auto-repair/tune-up'
    }, {
      label: 'Auto Cooling System Repair',
      href: '/auto-repair/cooling-system'
    }]
  }, {
    heading: 'Repairs',
    links: [{
      label: 'Brake Repair',
      href: '/auto-repair/brake-repair'
    }, {
      label: 'Engine Repair',
      href: '/auto-repair/engine-repair'
    }, {
      label: 'Steering & Suspension Repair',
      href: '/auto-repair/steering-suspension'
    }, {
      label: 'Tires & Wheels',
      href: '/auto-repair/tires-wheels'
    }, {
      label: 'Automotive Fuel Injection',
      href: '/auto-repair/fuel-injection'
    }]
  }, {
    heading: 'Helpful',
    links: [{
      label: 'Tesla Cyber Truck Maintenance',
      href: '/TeslaCyberTruckMaintenance'
    }, {
      label: 'Auto Myths Debunked',
      href: '/auto-repair/auto-myths'
    }, {
      label: 'Fuel Savings',
      href: '/auto-repair/fuel-savings'
    }]
  }];
  const dieselFleetGroups = [{
    heading: 'Fleet Services',
    links: [{
      label: 'Fleet Service',
      href: '/diesel-fleet-service.html'
    }, {
      label: 'Fleet Maintenance',
      href: '/services/fleet-maintenance'
    }]
  }, {
    heading: 'Diesel Repair & Engines',
    links: [{
      label: 'Diesel Engine Repair',
      href: '/dieselenginerepair.html'
    }, {
      label: 'Power Stroke',
      href: '/powerstrokerepair.html'
    }, {
      label: '6.0L Powerstroke',
      href: '/6_0lpowerstrokerepair.html'
    }, {
      label: '6.4L Powerstroke',
      href: '/6_4lpowerstrokerepair.html'
    }, {
      label: '7.3L Powerstroke',
      href: '/7_3lpowerstrokerepair.html'
    }, {
      label: 'Ford 7.3L Gas Engine',
      href: '/Ford-7.3L-Gas-Engine-Problems'
    }, {
      label: 'Isuzu Truck Repair',
      href: '/isuzu-truck-repair-near-me'
    }]
  }, {
    heading: 'Commercial / Work Truck',
    links: [{
      label: 'Drive Shaft Repair',
      href: '/driveshaftrepair.html'
    }, {
      label: 'Freight Box Repair',
      href: '/commercial/freight-box-repair'
    }, {
      label: 'Liftgate Info',
      href: '/commercial/liftgate-info'
    }, {
      label: 'Roll Up Door Service',
      href: '/commercial/roll-up-door-service'
    }, {
      label: 'Roll Up Door Parts',
      href: '/commercial/roll-up-door-parts'
    }, {
      label: 'Equipment Repainting',
      href: '/commercial/equipment-repainting'
    }]
  }, {
    heading: 'Partner Services',
    links: [{
      label: 'Horse Trailer Repair',
      href: '/Horse-Trailer-Repair'
    }, {
      label: 'Trailer Repair',
      href: '/Trailer-Repair'
    }, {
      label: 'Trailer Hitch Info',
      href: '/partner/trailer-hitch-info'
    }, {
      label: 'Travel Trailer Repair',
      href: '/partner/travel-trailer-repair'
    }, {
      label: 'Motor Home Repair',
      href: '/motor-home-repair.html'
    }, {
      label: 'Farm Equipment Repair',
      href: '/partner/farm-equipment-repair'
    }]
  }];
  const dotCdlGroups = [{
    heading: 'DOT & Compliance',
    links: [{
      label: 'DOT For Life',
      href: '/dot/dot-for-life'
    }, {
      label: 'Michigan DOT Inspection',
      href: '/michigandotinspection.html'
    }, {
      label: 'DOT Inspection',
      href: '/dot/dot-inspection'
    }, {
      label: 'DOT Number',
      href: '/dot/dot-number'
    }, {
      label: 'Cargo Securement Rules',
      href: '/Cargo-Securement-Rules'
    }, {
      label: 'Vehicle Inspection Aid',
      href: '/Vehicle-Inspection-Aid'
    }]
  }, {
    heading: 'CDL & Driver Resources',
    links: [{
      label: 'CDL Types',
      href: '/cdl/cdl-types'
    }, {
      label: 'CDL – Do I Need One',
      href: '/cdl/cdl-do-i-need-one'
    }, {
      label: 'CDL Testing Info',
      href: '/cdl/cdl-testing-info'
    }, {
      label: 'Hours of Service',
      href: '/cdl/hours-of-service'
    }, {
      label: 'Medical Card Info',
      href: '/cdl/medical-card-info'
    }, {
      label: 'GVW Page',
      href: '/cdl/gvw-page'
    }, {
      label: 'Vehicle & Load Size',
      href: '/cdl/vehicle-load-size'
    }, {
      label: 'Over Sized Load',
      href: '/cdl/over-sized-load'
    }, {
      label: 'Interstate Operating Authority',
      href: '/cdl/interstate-operating-authority'
    }, {
      label: 'Registration & Licensing Forms',
      href: '/cdl/registration-licensing-forms'
    }, {
      label: 'Traffic Violation Convictions',
      href: '/cdl/traffic-violation-convictions'
    }, {
      label: 'What Else Do I Need to Know?',
      href: '/cdl/what-else-do-i-need-to-know'
    }]
  }, {
    heading: 'Professional Services',
    links: [{
      label: 'Professional Witness',
      href: '/services/professional-witness'
    }]
  }];
  const blogLinks = [{
    label: 'CDL Blog',
    href: 'https://www.garrettauto.com/182.html'
  }, {
    label: 'Automotive Blog',
    href: 'https://www.garrettauto.com/143.html'
  }, {
    label: 'Diesel Blog',
    href: 'https://www.garrettauto.com/132.html'
  }, {
    label: 'DOT Inspection',
    href: 'https://www.garrettauto.com/230.html'
  }];
  return <>
      {/* 1) TOP SEO STRIP - NOT STICKY (scrolls away) */}
      <div className="bg-gray-50 border-b border-gray-100" data-id="element-559">
        <div className="container mx-auto px-4 py-1.5" data-id="element-560">
          <p className="text-center text-xs text-gray-400" data-id="element-561">
            DOT Inspection - Diesel Truck Repair - Semi Truck Repair - Ford
            Truck Repair - GM / Chevy Truck Repair - Serving Southeastern
            Michigan and Detroit Metro Community
          </p>
        </div>
      </div>

      {/* 2) MAIN HEADER - STICKY, WHITE BACKGROUND */}
      <header className="sticky top-0 z-50 bg-white shadow-md" data-id="element-562">
        <div className="container mx-auto px-4" data-id="element-563">
          {/* DESKTOP LAYOUT */}
          <div className="hidden lg:flex items-center justify-between py-3" data-id="element-564">
            {/* LEFT: Logo + Address */}
            <div className="flex items-center gap-4" data-id="element-565">
              <a href="/" data-id="element-566">
                <img src="http://www.garrettauto.com/uploaded/images/MobileLogo/translogo.png" alt="Garrett Auto & Truck Repair" className="h-20 w-auto" data-id="element-567" />
              </a>

              <a href="https://maps.google.com/?q=24175+Industrial+Park+Dr.,+Farmington+Hills,+MI+48335" target="_blank" rel="noopener noreferrer" className="flex items-start text-gray-700 hover:text-[#B1050B] transition-colors" data-id="element-568">
                <MapPinIcon size={14} className="mr-1.5 text-[#B1050B] flex-shrink-0 mt-0.5" data-id="element-569" />
                <div className="text-xs font-medium leading-tight" data-id="element-570">
                  <div data-id="element-571">24175 Industrial</div>
                  <div data-id="element-572">Park Dr.</div>
                </div>
              </a>
            </div>

            {/* CENTER: Navigation */}
            <nav className="flex items-center space-x-5" data-id="element-573">
              <a href="/" className="text-gray-800 hover:text-[#B1050B] transition-colors font-medium text-base" data-id="element-574">
                Home
              </a>

              {/* Auto Repair Dropdown */}
              <div className="relative" onMouseEnter={() => setIsAutoRepairOpen(true)} onMouseLeave={() => setIsAutoRepairOpen(false)} data-id="element-575">
                <button className="text-gray-800 hover:text-[#B1050B] transition-colors font-medium text-base flex items-center gap-0.5" data-id="element-576">
                  Auto & Truck Repair
                  <ChevronDownIcon size={16} data-id="element-577" />
                </button>

                {isAutoRepairOpen && <div className="absolute top-full left-1/2 -translate-x-1/2 pt-2" data-id="element-578">
                    <div className="bg-white text-gray-900 rounded-lg shadow-2xl border border-gray-200 min-w-[700px] p-6" data-id="element-579">
                      <div className="grid grid-cols-3 gap-6" data-id="element-580">
                        {autoRepairGroups.map((group, index) => <div key={index} data-id="element-581">
                            <h4 className="font-bold text-[#B1050B] mb-3 text-base border-b-2 border-[#D4AF37] pb-2" data-id="element-582">
                              {group.heading}
                            </h4>
                            <ul className="space-y-2" data-id="element-583">
                              {group.links.map(link => <li key={link.href} data-id="element-584">
                                  <a href={link.href} className="text-gray-700 hover:text-[#B1050B] transition-colors text-sm block py-1" data-id="element-585">
                                    {link.label}
                                  </a>
                                </li>)}
                            </ul>
                          </div>)}
                      </div>
                    </div>
                  </div>}
              </div>

              {/* Diesel & Fleet Dropdown */}
              <div className="relative" onMouseEnter={() => setIsDieselFleetOpen(true)} onMouseLeave={() => setIsDieselFleetOpen(false)} data-id="element-586">
                <button className="text-gray-800 hover:text-[#B1050B] transition-colors font-medium text-base flex items-center gap-0.5" data-id="element-587">
                  Diesel & Fleet
                  <ChevronDownIcon size={16} data-id="element-588" />
                </button>

                {isDieselFleetOpen && <div className="absolute top-full left-1/2 -translate-x-1/2 pt-2" data-id="element-589">
                    <div className="bg-white text-gray-900 rounded-lg shadow-2xl border border-gray-200 min-w-[800px] p-6" data-id="element-590">
                      <div className="grid grid-cols-4 gap-6" data-id="element-591">
                        {dieselFleetGroups.map((group, index) => <div key={index} data-id="element-592">
                            <h4 className="font-bold text-[#B1050B] mb-3 text-base border-b-2 border-[#D4AF37] pb-2" data-id="element-593">
                              {group.heading}
                            </h4>
                            <ul className="space-y-2" data-id="element-594">
                              {group.links.map(link => <li key={link.href} data-id="element-595">
                                  <a href={link.href} className="text-gray-700 hover:text-[#B1050B] transition-colors text-sm block py-1" data-id="element-596">
                                    {link.label}
                                  </a>
                                </li>)}
                            </ul>
                          </div>)}
                      </div>
                    </div>
                  </div>}
              </div>

              {/* DOT / CDL Dropdown */}
              <div className="relative" onMouseEnter={() => setIsDotCdlOpen(true)} onMouseLeave={() => setIsDotCdlOpen(false)} data-id="element-597">
                <button className="text-gray-800 hover:text-[#B1050B] transition-colors font-medium text-base flex items-center gap-0.5" data-id="element-598">
                  DOT / CDL
                  <ChevronDownIcon size={16} data-id="element-599" />
                </button>

                {isDotCdlOpen && <div className="absolute top-full left-1/2 -translate-x-1/2 pt-2" data-id="element-600">
                    <div className="bg-white text-gray-900 rounded-lg shadow-2xl border border-gray-200 min-w-[700px] p-6" data-id="element-601">
                      <div className="grid grid-cols-3 gap-6" data-id="element-602">
                        {dotCdlGroups.map((group, index) => <div key={index} data-id="element-603">
                            <h4 className="font-bold text-[#B1050B] mb-3 text-base border-b-2 border-[#D4AF37] pb-2" data-id="element-604">
                              {group.heading}
                            </h4>
                            <ul className="space-y-2" data-id="element-605">
                              {group.links.map(link => <li key={link.href} data-id="element-606">
                                  <a href={link.href} className="text-gray-700 hover:text-[#B1050B] transition-colors text-sm block py-1" data-id="element-607">
                                    {link.label}
                                  </a>
                                </li>)}
                            </ul>
                          </div>)}
                      </div>
                    </div>
                  </div>}
              </div>

              {/* Blogs Dropdown */}
              <div className="relative" onMouseEnter={() => setIsBlogsOpen(true)} onMouseLeave={() => setIsBlogsOpen(false)} data-id="element-608">
                <button className="text-gray-800 hover:text-[#B1050B] transition-colors font-medium text-base flex items-center gap-0.5" data-id="element-609">
                  Blogs
                  <ChevronDownIcon size={16} data-id="element-610" />
                </button>

                {isBlogsOpen && <div className="absolute top-full left-1/2 -translate-x-1/2 pt-2" data-id="element-611">
                    <div className="bg-white text-gray-900 rounded-lg shadow-2xl border border-gray-200 min-w-[250px] p-6" data-id="element-612">
                      <ul className="space-y-2" data-id="element-613">
                        {blogLinks.map(link => <li key={link.href} data-id="element-614">
                            <a href={link.href} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-[#B1050B] transition-colors text-sm block py-1" data-id="element-615">
                              {link.label}
                            </a>
                          </li>)}
                      </ul>
                    </div>
                  </div>}
              </div>

              <a href="/contact" className="text-gray-800 hover:text-[#B1050B] transition-colors font-medium text-base" data-id="element-616">
                Contact
              </a>
            </nav>

            {/* RIGHT: Contact Cluster */}
            <div className="flex flex-col items-end" data-id="element-617">
              <a href="tel:2484788382" className="flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-4 py-2 rounded-lg font-bold transition-colors shadow-md text-sm leading-tight" data-id="element-618">
                <PhoneIcon size={16} className="mr-2 flex-shrink-0" data-id="element-619" />
                <div className="flex flex-col" data-id="element-620">
                  <span data-id="element-621">Call or Text:</span>
                  <span data-id="element-622">(248) 478-8382</span>
                </div>
              </a>
            </div>
          </div>

          {/* MOBILE LAYOUT */}
          <div className="lg:hidden" data-id="element-623">
            {/* Row 1: Logo + Phone Button */}
            <div className="flex items-center justify-between py-3" data-id="element-624">
              <a href="/" data-id="element-625">
                <img src="http://www.garrettauto.com/uploaded/images/MobileLogo/translogo.png" alt="Garrett Auto & Truck Repair" className="h-14 w-auto" data-id="element-626" />
              </a>

              <div className="flex items-center gap-2" data-id="element-627">
                <a href="tel:2484788382" className="flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-4 py-2 rounded font-bold transition-colors text-sm" data-id="element-628">
                  <PhoneIcon size={16} className="mr-1.5" data-id="element-629" />
                  <span data-id="element-630">Call</span>
                </a>
                <button onClick={toggleMenu} className="text-gray-800" data-id="element-631">
                  <MenuIcon size={32} data-id="element-632" />
                </button>
              </div>
            </div>

            {/* Row 2: Address */}
            <div className="pb-3 space-y-1 border-t border-gray-100 pt-2" data-id="element-633">
              <a href="https://maps.google.com/?q=24175+Industrial+Park+Dr.,+Farmington+Hills,+MI+48335" target="_blank" rel="noopener noreferrer" className="flex items-center text-gray-700 hover:text-[#B1050B] transition-colors text-xs" data-id="element-634">
                <MapPinIcon size={14} className="mr-1.5 text-[#B1050B] flex-shrink-0" data-id="element-635" />
                <span className="font-medium" data-id="element-636">
                  24175 Industrial Park Dr., Farmington Hills, MI 48335
                </span>
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      {isMenuOpen && <div className="lg:hidden fixed inset-0 bg-white z-50 flex flex-col" data-id="element-637">
          <div className="container mx-auto px-4 py-4 flex justify-between items-center border-b border-gray-200" data-id="element-638">
            <img src="http://www.garrettauto.com/uploaded/images/MobileLogo/translogo.png" alt="Garrett Auto & Truck Repair" className="h-12 w-auto" data-id="element-639" />
            <button onClick={toggleMenu} className="text-gray-800" data-id="element-640">
              <XIcon size={32} data-id="element-641" />
            </button>
          </div>

          <div className="flex flex-col items-center justify-start flex-grow overflow-y-auto py-8 px-8" data-id="element-642">
            <a href="/" className="text-gray-800 hover:text-[#B1050B] transition-colors font-medium text-xl py-3" onClick={toggleMenu} data-id="element-643">
              Home
            </a>

            {/* Auto Repair Mobile */}
            <div className="w-full" data-id="element-644">
              <button onClick={() => setMobileAutoRepairOpen(!mobileAutoRepairOpen)} className="w-full text-center text-gray-800 hover:text-[#B1050B] transition-colors font-medium text-xl py-3 flex items-center justify-center" data-id="element-645">
                Auto & Truck Repair
                <ChevronDownIcon size={20} className={`ml-2 transition-transform ${mobileAutoRepairOpen ? 'rotate-180' : ''}`} data-id="element-646" />
              </button>

              {mobileAutoRepairOpen && <div className="bg-gray-50 rounded-lg p-4 mb-4 mt-2 w-full space-y-4" data-id="element-647">
                  {autoRepairGroups.map((group, groupIndex) => <div key={groupIndex} data-id="element-648">
                      <button onClick={() => {
                if (groupIndex === 0) setMobileGroup1Open(!mobileGroup1Open);
                if (groupIndex === 1) setMobileGroup2Open(!mobileGroup2Open);
                if (groupIndex === 2) setMobileGroup3Open(!mobileGroup3Open);
              }} className="w-full text-left font-bold text-[#B1050B] text-base border-b border-gray-200 pb-2 flex items-center justify-between" data-id="element-649">
                        {group.heading}
                        <ChevronDownIcon size={16} className={`transition-transform ${groupIndex === 0 && mobileGroup1Open || groupIndex === 1 && mobileGroup2Open || groupIndex === 2 && mobileGroup3Open ? 'rotate-180' : ''}`} data-id="element-650" />
                      </button>

                      {(groupIndex === 0 && mobileGroup1Open || groupIndex === 1 && mobileGroup2Open || groupIndex === 2 && mobileGroup3Open) && <ul className="space-y-2 ml-2 mt-2" data-id="element-651">
                          {group.links.map(link => <li key={link.href} data-id="element-652">
                              <a href={link.href} className="text-gray-700 hover:text-[#B1050B] transition-colors text-sm block py-1" onClick={toggleMenu} data-id="element-653">
                                {link.label}
                              </a>
                            </li>)}
                        </ul>}
                    </div>)}
                </div>}
            </div>

            {/* Diesel & Fleet Mobile */}
            <div className="w-full" data-id="element-654">
              <button onClick={() => setMobileDieselFleetOpen(!mobileDieselFleetOpen)} className="w-full text-center text-gray-800 hover:text-[#B1050B] transition-colors font-medium text-xl py-3 flex items-center justify-center" data-id="element-655">
                Diesel & Fleet
                <ChevronDownIcon size={20} className={`ml-2 transition-transform ${mobileDieselFleetOpen ? 'rotate-180' : ''}`} data-id="element-656" />
              </button>

              {mobileDieselFleetOpen && <div className="bg-gray-50 rounded-lg p-4 mb-4 mt-2 w-full space-y-4" data-id="element-657">
                  {dieselFleetGroups.map((group, groupIndex) => <div key={groupIndex} data-id="element-658">
                      <button onClick={() => {
                if (groupIndex === 0) setMobileDieselGroup1Open(!mobileDieselGroup1Open);
                if (groupIndex === 1) setMobileDieselGroup2Open(!mobileDieselGroup2Open);
                if (groupIndex === 2) setMobileDieselGroup3Open(!mobileDieselGroup3Open);
                if (groupIndex === 3) setMobileDieselGroup4Open(!mobileDieselGroup4Open);
              }} className="w-full text-left font-bold text-[#B1050B] text-base border-b border-gray-200 pb-2 flex items-center justify-between" data-id="element-659">
                        {group.heading}
                        <ChevronDownIcon size={16} className={`transition-transform ${groupIndex === 0 && mobileDieselGroup1Open || groupIndex === 1 && mobileDieselGroup2Open || groupIndex === 2 && mobileDieselGroup3Open || groupIndex === 3 && mobileDieselGroup4Open ? 'rotate-180' : ''}`} data-id="element-660" />
                      </button>

                      {(groupIndex === 0 && mobileDieselGroup1Open || groupIndex === 1 && mobileDieselGroup2Open || groupIndex === 2 && mobileDieselGroup3Open || groupIndex === 3 && mobileDieselGroup4Open) && <ul className="space-y-2 ml-2 mt-2" data-id="element-661">
                          {group.links.map(link => <li key={link.href} data-id="element-662">
                              <a href={link.href} className="text-gray-700 hover:text-[#B1050B] transition-colors text-sm block py-1" onClick={toggleMenu} data-id="element-663">
                                {link.label}
                              </a>
                            </li>)}
                        </ul>}
                    </div>)}
                </div>}
            </div>

            {/* DOT / CDL Mobile */}
            <div className="w-full" data-id="element-664">
              <button onClick={() => setMobileDotCdlOpen(!mobileDotCdlOpen)} className="w-full text-center text-gray-800 hover:text-[#B1050B] transition-colors font-medium text-xl py-3 flex items-center justify-center" data-id="element-665">
                DOT / CDL
                <ChevronDownIcon size={20} className={`ml-2 transition-transform ${mobileDotCdlOpen ? 'rotate-180' : ''}`} data-id="element-666" />
              </button>

              {mobileDotCdlOpen && <div className="bg-gray-50 rounded-lg p-4 mb-4 mt-2 w-full space-y-4" data-id="element-667">
                  {dotCdlGroups.map((group, groupIndex) => <div key={groupIndex} data-id="element-668">
                      <button onClick={() => {
                if (groupIndex === 0) setMobileDotGroup1Open(!mobileDotGroup1Open);
                if (groupIndex === 1) setMobileDotGroup2Open(!mobileDotGroup2Open);
                if (groupIndex === 2) setMobileDotGroup3Open(!mobileDotGroup3Open);
              }} className="w-full text-left font-bold text-[#B1050B] text-base border-b border-gray-200 pb-2 flex items-center justify-between" data-id="element-669">
                        {group.heading}
                        <ChevronDownIcon size={16} className={`transition-transform ${groupIndex === 0 && mobileDotGroup1Open || groupIndex === 1 && mobileDotGroup2Open || groupIndex === 2 && mobileDotGroup3Open ? 'rotate-180' : ''}`} data-id="element-670" />
                      </button>

                      {(groupIndex === 0 && mobileDotGroup1Open || groupIndex === 1 && mobileDotGroup2Open || groupIndex === 2 && mobileDotGroup3Open) && <ul className="space-y-2 ml-2 mt-2" data-id="element-671">
                          {group.links.map(link => <li key={link.href} data-id="element-672">
                              <a href={link.href} className="text-gray-700 hover:text-[#B1050B] transition-colors text-sm block py-1" onClick={toggleMenu} data-id="element-673">
                                {link.label}
                              </a>
                            </li>)}
                        </ul>}
                    </div>)}
                </div>}
            </div>

            {/* Blogs Mobile */}
            <div className="w-full" data-id="element-674">
              <button onClick={() => setMobileBlogsOpen(!mobileBlogsOpen)} className="w-full text-center text-gray-800 hover:text-[#B1050B] transition-colors font-medium text-xl py-3 flex items-center justify-center" data-id="element-675">
                Blogs
                <ChevronDownIcon size={20} className={`ml-2 transition-transform ${mobileBlogsOpen ? 'rotate-180' : ''}`} data-id="element-676" />
              </button>

              {mobileBlogsOpen && <div className="bg-gray-50 rounded-lg p-4 mb-4 mt-2 w-full" data-id="element-677">
                  <ul className="space-y-2" data-id="element-678">
                    {blogLinks.map(link => <li key={link.href} data-id="element-679">
                        <a href={link.href} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-[#B1050B] transition-colors text-sm block py-1" onClick={toggleMenu} data-id="element-680">
                          {link.label}
                        </a>
                      </li>)}
                  </ul>
                </div>}
            </div>

            <a href="/contact" className="text-gray-800 hover:text-[#B1050B] transition-colors font-medium text-xl py-3" onClick={toggleMenu} data-id="element-681">
              Contact
            </a>
          </div>
        </div>}
    </>;
}